import getSrParentListUseCase from "@domains/features/ServiceRequest/useCases/SrParentListUseCase";
import EsignURLUseCase from "@domains/features/ServiceRequest/useCases/ESignURLUseCase";
import PreFilledFormPDFUseCase from "@domains/features/ServiceRequest/useCases/PreFilledFormPDFUseCase";
export default (function (repo) {
    return {
        serviceRequest: {
            getSrParentListUseCase: new getSrParentListUseCase(repo.serviceRequest),
            preFilledFormPDF: new PreFilledFormPDFUseCase(repo.serviceRequest),
            eSignURL: new EsignURLUseCase(repo.serviceRequest),
        },
    };
});
